import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ModalContainer } from '../../components/ModalContainer';
import { EGBasicSelect } from '../../../../../MainComponents/Select/EGBasicSelect';
import { Box, Grid2, Stack, Typography, useTheme } from '@mui/material';
import _ from 'lodash';
import EGDatePicker from '../../../../../MainComponents/DatePicker/EGDatePicker';
import dayjs from 'dayjs';
import { EGInput } from '../../../../../MainComponents/Input/EGInput';
import { DragAndDropFiles, TemporalUploadedFile } from '../../components/InvestigationComponents';
import { EGSwitch } from '../../../../../MainComponents/Switch/Switch';
import { InvestigationButton } from '../../components/InvestigationButton';
import { createAttachment } from '../../../../../../apis';
import { enqueueSnackbar } from 'notistack';
import { useConstants } from '../../Main/useConstants';

const schemaChainOfCustody = {
  kind: "", //Tipo de movimiento
  date_collection: "", //Fecha de recopilación
  time_collection: "", //Hora de recopilación
  package: "", //descripcion de embalaje 
  status: "", //Estado en el que se encuentra
  place: "", //Lugar de custoria
  collector: "", //Persona que recibe
  facilitator: "", //Persona que entrega
  //nuevos campos
  // files: [],
  location: "",
  gps: "",
}

const validateForm = (form) => {
  const errors = {};
  if (!form.kind) {
    errors.kind = true;
  };
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
};

export const ChainOfCustody = ({
  show,
  onHide,
  selectedChainOfCustody,
  setSelectedChainOfCustody,
  evidences,
  idxEvidence,
  idxFile,
  handleSaveEvidenceDetails,
  existsChainOfCustody,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const { evidences: { kindMoveCustodyOpts }, selects: { hoursOpts } } = useConstants();

  const [chainOfCustody, setChainOfCustody] = useState(_.cloneDeep(schemaChainOfCustody));
  const [files, setFiles] = useState([]);

  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});

  const [addMovementEvidence, setAddMovementEvidence] = useState(false);

  useEffect(() => {
    if (!show) {
      resetValues();
    }
  }, [show]);

  useEffect(() => {
    if (selectedChainOfCustody !== null) {
      const coc = evidences[idxEvidence].cocs[selectedChainOfCustody];
      setChainOfCustody(coc);
      setAddMovementEvidence(Array.isArray(coc.files) && coc.files.length > 0 ? true : false);
    }
  }, [selectedChainOfCustody]);


  const handleChange = (e, diff) => {
    if (diff === "date_collection") {
      const newDate = e;
      setChainOfCustody({ ...chainOfCustody, date_collection: newDate ? dayjs(newDate).format('YYYY-MM-DD') : null });
    } else {
      const { name, value } = e.target;
      setChainOfCustody({ ...chainOfCustody, [name]: value });
    }
  }

  const handleChangeFiles = (newFiles) => {
    setFiles([ ...files, ...newFiles ]);
  }

  const handleExitFile = (idx) => {
    const newFiles = chainOfCustody.files.filter((f, i) => i !== idx);
    setChainOfCustody({ ...chainOfCustody, files: newFiles });
  }

  const handleRemoveFile = (idx) => {
    setFiles(files.filter((f, i) => i !== idx));
  }

  const handleMovementEvidence = (e) => {
    setAddMovementEvidence(e.target.checked);
    if (!e.target.checked) {
      setFiles([]);
    }
  }

  const handleSubmit = async() => {
    const [isValid, errors] = validateForm(chainOfCustody);
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
      return;
    };

    try {
      let attachments = [];
      if (files.length > 0) {
        const formData = new FormData();
        files.forEach(file => {
          formData.append("attachments", file);
        });
        const resp = await createAttachment(formData);
        const attachments_id = resp.attachments_id;
        attachments = attachments_id.map((id, idx) => ({
          file: id,
          name: files[idx].name,
          size: files[idx].size,
          type: files[idx].type,
        }));
      }

      const newEvidences = _.cloneDeep(evidences);
      const newCocs = Array.isArray(newEvidences[idxEvidence].cocs) ? newEvidences[idxEvidence].cocs : [];
      if (selectedChainOfCustody === null) {
        newCocs.push({ ...chainOfCustody, files: attachments });
      } else {
        newCocs[selectedChainOfCustody] = { ...chainOfCustody, files: [ ...chainOfCustody.files, ...attachments ] };
      }
      newEvidences[idxEvidence].cocs = newCocs;
      
      handleSaveEvidenceDetails(newEvidences);
      resetValues();
      onHide();
    } catch (error) {
      console.log(error);
    }
  }

  const resetValues = () => {
    setChainOfCustody(_.cloneDeep(schemaChainOfCustody));
    setFiles([]);
    setAddMovementEvidence(false);
    setSelectedChainOfCustody(null);
    setErrors({});
    setTriedToSave(false);
  }

  const returnIsValid = (error) => {
    if (!triedToSave) return null;
    if (error) return false;
    return true;
  }


  return (
    <ModalContainer
      show={show}
      onHide={onHide}
      title={t("Evidences.chain_of_custody")}
    >
      {/* Header */}
      <Typography fontWeight={700} fontSize={28} color={theme.palette.ethicsBlue.main}>
        {existsChainOfCustody ? t("Evidences.add_movement") : t("Evidences.chain_of_custody")}
      </Typography>
      <Typography fontSize={16} color="oxfordBlue" >
        {existsChainOfCustody ? t("Evidences.add_movement_evidence") : t("Evidences.add_chain_of_custody")}
      </Typography>

      <hr />

      <Grid2 container spacing={2}>
        
        <Grid2 size={{ xs: 12, md: 6 }}>
          <EGBasicSelect
            label={t("Evidences.type_of_movement")}
            name="kind"
            value={chainOfCustody.kind}
            onChange={handleChange}
            options={kindMoveCustodyOpts}
            showHelpText={false}
            isValid={returnIsValid(errors.kind) ?? null}
            required={true}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
          <EGDatePicker
            label={`${t("Evidences.date")}`}
            name="date_collection"
            value={chainOfCustody.date_collection ? dayjs(chainOfCustody.date_collection) : null}
            onChange={(e) => handleChange(e, "date_collection")}
            className="date-picker-deadline"
            format="DD/MMM/YYYY"
          />
          
          <Box width={140}>
            <EGBasicSelect
              label={t("Evidences.hour")}
              name="time_collection"
              value={chainOfCustody.time_collection}
              onChange={handleChange}
              options={hoursOpts}
              showHelpText={false}
            />
          </Box>
        </Grid2>

        <Grid2 size={12}>
          <EGInput
            label={`${t("Evidences.description_of_packaging")}`}
            name="package"
            value={chainOfCustody.package}
            onChange={handleChange}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <EGInput
            label={`${t("Evidences.status")}`}
            name="status"
            value={chainOfCustody.status}
            onChange={handleChange}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <EGInput
            label={`${t("Evidences.place")}`}
            name="place"
            value={chainOfCustody.place}
            onChange={handleChange}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <EGInput
            label={`${t("Evidences.facilitator")}`}
            name="facilitator"
            value={chainOfCustody.facilitator}
            onChange={handleChange}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <EGInput
            label={`${t("Evidences.collector")}`}
            name="collector"
            value={chainOfCustody.collector}
            onChange={handleChange}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, lg: 6 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
          <Typography fontSize={16} fontWeight={600} color={theme.palette.secondary.main}>
            {t("Evidences.add_movement_evidence_description")}
          </Typography>
          <EGSwitch
            size="small"
            checked={addMovementEvidence} 
            onChange={handleMovementEvidence}
          />
        </Grid2>

        {
          addMovementEvidence &&
          <Grid2 size={12}>
            <DragAndDropFiles
              onFileSelect={handleChangeFiles}
              multiple
            />
          </Grid2>
        }

        <Grid2 size={12} display="flex" flexWrap="wrap" gap={1}>
          {
            Array.isArray(chainOfCustody.files) && chainOfCustody.files.map((file, idx) => (
              <TemporalUploadedFile
                key={idx}
                name={file.name}
                size={file.size}
                iconName="trash_can"
                iconColor={theme.palette.red.main}
                iconAction={() => handleExitFile(idx)}
              />
            ))
          }
          {
            files.length > 0 && files.map((file, idx) => (
              <TemporalUploadedFile
                key={idx}
                name={file.name}
                size={file.size}
                iconName="trash_can"
                iconColor={theme.palette.red.main}
                iconAction={() => handleRemoveFile(idx)}
              />
            ))
          }
        </Grid2>

      </Grid2>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2} 
        justifyContent={"flex-end"}
        mt={2}
      >
        <Stack direction="row" spacing={2}>
          <InvestigationButton
            label={t("Evidences.cancel")}
            variant="main"
            outlined
            onClick={onHide}
          />
          <InvestigationButton
            label={t("Evidences.save")}
            variant="main"
            onClick={handleSubmit}
          />
        </Stack>
      </Stack>

    </ModalContainer>
  )
}
